import { Component, type ReactNode } from 'react';

interface Props {
  /** What to show instead of the crashed subtree (nothing by default). */
  fallback?: (error: Error) => ReactNode;
  onError?: (error: Error) => void;
  children: ReactNode;
}

/** Keeps one broken part (a lesson block, a question) from taking down the whole page. */
export class ErrorBoundary extends Component<Props, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: unknown) {
    return { error: error instanceof Error ? error : new Error(String(error)) };
  }

  componentDidCatch(error: unknown) {
    console.error(error);
    this.props.onError?.(error instanceof Error ? error : new Error(String(error)));
  }

  render() {
    if (this.state.error) return this.props.fallback ? this.props.fallback(this.state.error) : null;
    return this.props.children;
  }
}
